import history from '@webapp/utils/history'
import configureStore from './configureStore'

// Redux State Management
const initialState = {}
export const store = configureStore(initialState, history)
